export const contactsData = {
    email: 'hello@saiteja.pro',
    phone: '+1 (682)-433-2239',
    address: 'Austin, Texas',
    calendly: 'https://calendly.com/saitejabhoomraogari',
    sheetAPI: ''
};